"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextArea = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../style/settings.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// Style
var TextArea = function TextArea(_ref) {
  var id = _ref.id,
      className = _ref.className,
      style = _ref.style,
      label = _ref.label,
      surlabel = _ref.surlabel,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      maxLength = _ref.maxLength,
      row = _ref.row,
      onChange = _ref.onChange,
      error = _ref.error,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled;

  function getLabelGroup() {
    // Input Label
    var inputLabel = /*#__PURE__*/_react.default.createElement("span", {
      className: "shpmtc-input__label-group__label"
    }, label);

    var inputSurlabel = /*#__PURE__*/_react.default.createElement("span", {
      className: "shpmtc-input__label-group__surlabel"
    }, surlabel);

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "shpmtc-input__label-group"
    }, label ? inputLabel : undefined, surlabel ? inputSurlabel : undefined);
  }

  function getInputGroup() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "shpmtc-input__group"
    }, /*#__PURE__*/_react.default.createElement("textarea", {
      id: id,
      placeholder: placeholder,
      disabled: disabled,
      value: value,
      defaultValue: defaultValue,
      maxLength: maxLength,
      rows: row,
      onChange: onChange
    }, value));
  }

  function getErrorMsg() {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "shpmtc-input__error-msg"
    }, error);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    style: style,
    className: "\n        shpmtc-input \n        ".concat(className, " \n        ").concat(disabled ? 'shpmtc-input--disabled' : '', " \n        ").concat(error ? 'shpmtc-input--error' : '', "\n      ")
  }, label || surlabel ? getLabelGroup() : null, getInputGroup(), error ? getErrorMsg() : undefined);
}; // Prop Types


exports.TextArea = TextArea;
TextArea.defaultProps = {
  id: undefined,
  style: null,
  value: undefined,
  defaultValue: undefined,
  placeholder: undefined,
  label: undefined,
  surlabel: undefined,
  className: '',
  disabled: false,
  row: undefined,
  error: undefined,
  maxLength: undefined,
  onChange: function onChange() {
    return null;
  }
};
TextArea.propTypes = {
  id: _propTypes.default.string,
  style: _propTypes.default.instanceOf(Object),
  value: _propTypes.default.any,
  defaultValue: _propTypes.default.any,
  placeholder: _propTypes.default.string,
  label: _propTypes.default.string,
  surlabel: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  row: _propTypes.default.string,
  error: _propTypes.default.string,
  maxLength: _propTypes.default.string,
  onChange: _propTypes.default.func
};
var _default = TextArea;
exports.default = _default;